import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      const url = state.url;

      if (url.startsWith('/club') && this.authService.isClub()) return true;
      if (url.startsWith('/federation') && this.authService.isFederation()) return true;
      if (url.startsWith('/arbitre') && this.authService.isArbitre()) return true;
      if (url.startsWith('/delegue') && this.authService.isDelegue()) return true;

      this.router.navigate([this.authService.getHomeRoute()]);
      return false;
    }

    this.router.navigate(['/accueil']);
    return false;
  }
}
